import React, { useEffect, useState } from "react";
import css from "./Info.module.css";
import { useSingleConversion } from "../../../hooks/conversion";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NodeLink from "./NodeLink";
import { labelIdentifiers } from "../Config/Identifier";

const SingleConversion = ({
  allowed_conversion,
  label,
  pathwayInternalId,
  native,
  nodeId,
  onChangeLabel,
  protein_type,
}) => {
  const [chosenValues, setChosenValues] = useState({
    pathwayInternalId: null,
    native: null,
    to_type: null,
    protein_type: null,
  });
  const [optionValue, setOptionValue] = useState("");

  useEffect(() => {
    setOptionValue("");
    setChosenValues({
      pathwayInternalId: null,
      native: null,
      to_type: null,
      protein_type: null,
    });
  }, [native]);

  const onChange = (currentValue) => {
    setOptionValue(currentValue);
    if (currentValue === "") {
      setChosenValues({
        pathwayInternalId: null,
        native: null,
        to_type: null,
        protein_type: null,
      });
    } else {
      setChosenValues({
        pathwayInternalId: pathwayInternalId,
        native: native,
        to_type: currentValue,
        nodeId: nodeId,
        onChangeLabel: onChangeLabel,
        protein_type: protein_type,
      });
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto auto",
        gridRowGap: "5px",
      }}
    >
      <p className={css.entryInfo}>
        <b>
          {label}
          {": "}
        </b>
        <select
          onChange={(event) => {
            onChange(event.currentTarget.value);
          }}
          value={optionValue}
        >
          <option key={"--"} value="">
            ---
          </option>
          {allowed_conversion.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {choice.name in labelIdentifiers
                ? labelIdentifiers[choice.name]
                : choice.name}
            </option>
          ))}
        </select>
      </p>
      {optionValue !== "" ? (
        <ConversionResponse chosenValues={chosenValues} />
      ) : null}
    </div>
  );
};

export default SingleConversion;

const ConversionResponse = ({ chosenValues }) => {
  const { conversionData, isLoading } = useSingleConversion(
    chosenValues.pathwayInternalId,
    chosenValues.native,
    chosenValues.to_type
  );

  return isLoading ? (
    <FontAwesomeIcon icon="spinner" spin style={{ placeSelf: "center" }} />
  ) : (
    <TableResults
      conversions={conversionData.results}
      nodeId={chosenValues.nodeId}
      onChangeLabel={chosenValues.onChangeLabel}
      nativeBool={chosenValues.to_type === chosenValues.protein_type}
    />
  );
};

const TableResults = ({ conversions, nodeId, onChangeLabel, nativeBool }) => {
  const onClick = (nodeId, newLabel, newType) => {
    onChangeLabel(nodeId, newLabel, newType, nativeBool);
  };

  return (
    <div
      style={{
        maxHeight: "15rem",
        overflow: "scroll",
        width: "95%",
      }}
    >
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Conversion</th>
            <th>Utils</th>
          </tr>
        </thead>
        <tbody>
          {conversions.map((entry) => (
            <tr key={`${entry.type} ${entry.conv}`}>
              <td>{entry.type}</td>
              <td>
                <NodeLink label={entry.conv} type={entry.type} />
              </td>
              <td>
                <button onClick={() => onClick(nodeId, entry.conv, entry.type)}>
                  use as label
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
